import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SeErrorStateMatcher } from '../../../utils/error-state-matcher';
import { DateInputEnum } from '../../../models/date-input.enum';
import { MaskConfigOptions } from '@se/ui.datagrid';
import { Separators, ArrowBehaviours } from '../../../directives/mask-directive/mask-options';
import { customMaskedDateValidator } from '../../../utils/custom-masked-date-validator';

/**
 * Base Editor Custom AgGrid for Date/DateTime/Time Input.
 * It contains common functionalities used by DateCellEditorInlineComponent
 * and DateCellEditorPopupComponent
 *      this.dateInputFormat = this.params['dateInputFormat'] || 'ddMMyy'; // TODO creare funzione per formattare l'imput
        this.timeInputFormat = this.params['timeInputFormat'] || 'hhmm'; // TODO creare funzione per formattare l'imput
        this.dateTimeInputFormat = this.params['dateTimeInputFormat'] || 'hhmm'; // TODO: splittare datetime nei due di sopra
        this.dateSeparator = this.params['dateSeparator'] || '/';
        this.timeSeparator = this.params['timeSeparator'] || ':';
 */
@Component({
    template: ''
})
export class MaskedDateCellEditorBaseComponent implements OnInit {
    /**
     * Current value of the cell
     * ngModel setted by DateCellEditorComponent
     */
    @Input() value: string;

    /**
     * Type of the input:
     * - datetime
     * - date
     * - time
     */
    @Input() inputType: DateInputEnum;

    /**
     *  (Optional) it allows to specify if the filed is mandatory
     */
    @Input() required: boolean;

    /**
     *   set date format
     */
    @Input() dateInputFormat: string;

    /**
     *   set time format
     */
    @Input() timeInputFormat: string;

    /**
     *   set date  time format
     */
    @Input() dateTimeInputFormat: string;

    /**
     *   set date separator
     */
    @Input() dateSeparator: string;

    /**
     *   set time separator
    */
    @Input() timeSeparator: string;

    /**
     * Event emitted when the reactive form is ready
     */
    @Output() formReady: EventEmitter<FormControl> = new EventEmitter<FormControl>();

    @ViewChild('dateInput', { static: false, read: ElementRef }) dateInput: ElementRef;

    formControl: FormControl;
    matcher = new SeErrorStateMatcher();
    _inputType = 'text';
    maskConfigOptions: MaskConfigOptions;

    ngOnInit(): void {
        this.formControl = new FormControl(this.value, this.required ?
            [customMaskedDateValidator(this.inputType)
            ] : []);


        switch (this.inputType) {
            case DateInputEnum.DATE_TIME:
                this.maskConfigOptions = {
                    dateConfiguration: this.dateFormatToConfiguration(this.dateInputFormat),
                    timeConfiguration: this.timeFormatToConfiguration(this.timeInputFormat),
                    dateSeparator: this.getSeparator(this.dateSeparator, Separators.slash),
                    timeSeparator: this.getSeparator(this.dateSeparator, Separators.colon),
                    dateTimeSeparator: Separators.space,
                    minYear: 1900, // TODO: chiedere a Bellardi se lo vogliono in input
                    maxYear: 2500 // TODO: chiedere a Bellardi se lo vogliono in input
                }
                break;
            case DateInputEnum.TIME:
                this.maskConfigOptions = {
                    timeConfiguration: this.timeFormatToConfiguration(this.timeInputFormat),
                    timeSeparator: this.getSeparator(this.dateSeparator, Separators.colon)
                }
                break;
            case DateInputEnum.DATE:
            default:
                this.maskConfigOptions = {
                    dateConfiguration: this.dateFormatToConfiguration(this.dateInputFormat),
                    dateSeparator: this.getSeparator(this.dateSeparator, Separators.slash)
                }
                break;
        }
        this.maskConfigOptions.arrowBehaviours = ArrowBehaviours.circular_without_position;
        this.maskConfigOptions.ifNoEntryUseActualDate = true;
    }

    dateFormatToConfiguration(dateInputFormat): string {
        let output: string;
        output = dateInputFormat ? dateInputFormat.replace(new RegExp('YYYY','i'), 'yy').replace(new RegExp('[^dmy]', 'ig'), '') : 'ddMMyy';
        return output;
    }

    timeFormatToConfiguration(timeInputFormat): string {
        let output: string;
        output = timeInputFormat ? timeInputFormat.toLowerCase().replace(':','') : 'hhmm';
        return output;
    }

    dateTimeFormatToConfiguration(dateTimeInputFormat): string {
        let output: string;
        output = dateTimeInputFormat;
        // TODO: capire se ci serve
        return output;
    }

    getSeparator(dateSeparator: string, defaultSeparator: Separators): Separators { // || Separators.space
        let output: Separators;

        switch (dateSeparator) {
            case ':':
                output = Separators.colon;
                break;
            case '/':
                output = Separators.slash;
                break;
            case ' ':
                output = Separators.space;
                break;
            case '-':
                output = Separators.dash;
                break;
            case '.':
                output = Separators.dot;
                break;
            default:
                output = defaultSeparator;
                break;
        };
        return output;
    }
}
